module.exports = __webpack_public_path__ + "static/img/logo94.1991b36.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo94.png
// module id = y1yE
// module chunks = 1